export const initialState = {
  retailerPromos: {}
};

export const promosReducerKey = 'dataServicePromos';
export const promosReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'DS_PROMOS/SET_ALL_PROMOS':
      return {
        ...state,
        retailerPromos: action.payload
      };

    default:
      return state;
  }
};
